<script>
import { mapActions, mapState } from 'vuex';
import i18n from "@/plugins/i18n";

export default {
    props: {
        selectedCompanyId: {
            type: Number,
            required: true
        },

        userId: {
            type: Number,
            required: true
        },

        years: {
            type: Object,
            required: true
        },
    },

    data() {
        return {
            items: null,
            lang: "en",
        }
    },

    computed: {
        headers() {
            const lang = localStorage.getItem('lang');
            if (lang) {
                this.lang = lang;
            }

            const defaults = [
                { key: 'share', title: i18n.t('companyProfile.modal7.share'), flex: 4 },
                { key: 'number', title: i18n.t('companyProfile.modal7.number'), flex: 4 },
                { key: 'tonnes', title: i18n.t('companyProfile.modal7.tonnes'), flex: 4 },
                { key: 'rev_share', title: i18n.t('companyProfile.modal7.rev_share'), flex: 4 },
            ];

            if (lang === 'en') {
                return [
                    { key: 'year', title: i18n.t('companyProfile.modal7.year'), flex: 4 },
                    { key: 'name', title: i18n.t('companyProfile.modal7.product'), flex: 4 },
                    ...defaults
                ];
            } else if (lang === 'tr') {
                return [
                    { key: 'year', title: i18n.t('companyProfile.modal7.year'), flex: 4 },
                    { key: 'name', title: i18n.t('companyProfile.modal7.product_tr'), flex: 4 },
                    ...defaults
                ];
            } else {
                return [
                    { key: 'year', title: i18n.t('companyProfile.modal7.year'), flex: 4 },
                    { key: 'name', title: i18n.t('companyProfile.modal7.product'), flex: 4, no_lang_selected: true },
                    ...defaults
                ];
            }
        },
    },

    mounted() {
        this.getItems();
    },

    methods: {
        ...mapActions('company', [
            'getProducts',
        ]),

        getItems() {
            const params = {
                company_id: this.selectedCompanyId,
                is_deleted: false
            }

            this.getProducts(params)
                .then(res => {
                    this.items = res.data;
                })
        },
    }
}
</script>

<template>
    <div class="items">
        <div class="item-headers">
            <div v-for="header in headers" :key="header.key" :style="{ flex: header.flex }">
                {{ header.title }}
            </div>
        </div>

        <div class="item" v-for="(item, i) in items" :key="i">

            <select v-model="item.production_year" :style="{flex: headers[0].flex}" disabled>
                <option 
                    v-for="year in years" :key="year"
                    :value="year"
                >
                    {{ year }}
                </option>
            </select>

            <input v-if="lang === 'en'" type="text" :style="{ flex: headers[0].flex }" v-model="item.product_group_name" disabled/>
            
            <input v-if="lang === 'tr'" type="text" :style="{ flex: headers[0].flex }" v-model="item.product_group_name_tr" disabled/>

            <input type="number" :style="{ flex: headers[0].flex }" v-model="item.production_percent" disabled/>

            <input type="number" :style="{ flex: headers[0].flex }" v-model="item.production_count" disabled/>

            <input type="number" :style="{ flex: headers[0].flex }" v-model="item.production_tonnes" disabled/>

            <input type="number" :style="{ flex: headers[0].flex }" v-model="item.production_revenue_share" disabled/>
        </div>
    </div>
</template>

<style lang='scss' scoped>
.items {
    min-height: 100px !important;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
}

.item-headers {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;

    >div {
        text-align: left;
        margin: .5em;
        color: var(--sustainfinity-navy);
        font-weight: bold;
        font-size: 1.1em;
    }
}

.item {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: stretch;
    align-content: flex-start;
    flex-wrap: wrap;

    >.delete-item-button {
        margin: .5em;
        flex: 1;
        display: flex;
        align-items: center;

        >.cannot-edit {
            font-size: .8em;
            font-style: italic;
            color: var(--invalid-input);
        }

        >button {
            display: flex;
            align-items: center;

            outline: 0;
            border: 0;

            &:focus {
                outline: thin solid lightgray !important;
            }

            >i {
                color: var(--invalid-input);
            }

            &:hover {
                >i {
                    color: var(--invalid-input--hover);
                }
            }

            &:disabled {
                pointer-events: none !important;

                >i {
                    color: gray;
                }
            }
        }

        position: relative;

    }

    >input,
    select {
        text-align: left;
        margin: .5em;
        outline: 0;
        border: 0;
        border-bottom: thin solid lightgray;
        background-color: whitesmoke;

        transition: border-bottom 500ms;

        &:focus {
            border-bottom: thin solid black;
        }

        &:disabled {
            border-radius: .2em;
            background-color: rgb(221, 221, 221);
            cursor: not-allowed;
        }
    }
}
</style>
